'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Background = exports.Description = exports.Heading = exports.ContentAnimationWrap = exports.Content = exports.Wrapper = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  0% {\n    opacity: 0;\n    transform: translateX(-80px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n'], ['\n  0% {\n    opacity: 0;\n    transform: translateX(-80px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  0% {\n    opacity: 0;\n    transform: translateY(15px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n'], ['\n  0% {\n    opacity: 0;\n    transform: translateY(15px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n  padding: 50px 0;\n  min-height: ', ';\n  height: 100%;\n'], ['\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n  padding: 50px 0;\n  min-height: ', ';\n  height: 100%;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n'], ['\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  animation-duration: ', 'ms;\n  animation-delay: ', 'ms;\n  animation-fill-mode: forwards;\n  animation-name: ', ';\n  animation-timing-function: ease-out;\n'], ['\n  animation-duration: ', 'ms;\n  animation-delay: ', 'ms;\n  animation-fill-mode: forwards;\n  animation-name: ', ';\n  animation-timing-function: ease-out;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-family: ', ';\n  font-size: ', 'px;\n'], ['\n  color: ', ';\n  font-family: ', ';\n  font-size: ', 'px;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n color: ', ';\n font-size: ', 'px;\n'], ['\n color: ', ';\n font-size: ', 'px;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  animation-duration: ', 'ms;\n  animation-delay: ', 'ms;\n  animation-fill-mode: forwards;\n  animation-name: ', ';\n  animation-timing-function: ease-out;\n  background: url(', ') no-repeat center;\n  background-size: contain;\n  height: ', ';\n  margin: ', ' 0px 0px 0px;\n  min-width: ', ';\n  opacity: ', ';\n  width: 100%;\n'], ['\n  animation-duration: ', 'ms;\n  animation-delay: ', 'ms;\n  animation-fill-mode: forwards;\n  animation-name: ', ';\n  animation-timing-function: ease-out;\n  background: url(', ') no-repeat center;\n  background-size: contain;\n  height: ', ';\n  margin: ', ' 0px 0px 0px;\n  min-width: ', ';\n  opacity: ', ';\n  width: 100%;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _defaultNoContentBg = require('../../assets/images/defaultNoContentBg.svg');

var _defaultNoContentBg2 = _interopRequireDefault(_defaultNoContentBg);

var _noContentBgVariant = require('../../assets/images/noContentBgVariant1.svg');

var _noContentBgVariant2 = _interopRequireDefault(_noContentBgVariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var background = [_defaultNoContentBg2.default, _noContentBgVariant2.default];

var animateIn = (0, _styledComponents.keyframes)(_templateObject);

var animateUp = (0, _styledComponents.keyframes)(_templateObject2);

var Wrapper = exports.Wrapper = _styledComponents2.default.div(_templateObject3, function (props) {
  return props.minHeight;
});

Wrapper.displayName = 'Wrapper';
var Content = exports.Content = _styledComponents2.default.div(_templateObject4);

Content.displayName = 'Content';
var ContentAnimationWrap = exports.ContentAnimationWrap = _styledComponents2.default.div(_templateObject5, function (props) {
  return props.animationDuration;
}, function (props) {
  return props.animationDelay;
}, function (props) {
  return props.animate && animateUp;
});

ContentAnimationWrap.displayName = 'ContentAnimationWrap';
var Heading = exports.Heading = _styledComponents2.default.h3(_templateObject6, function (props) {
  return props.theme.color.base3;
}, function (props) {
  return props.theme.font.default;
}, function (props) {
  return props.theme.size['1'];
});

Heading.displayName = 'Heading';
var Description = exports.Description = _styledComponents2.default.p(_templateObject7, function (props) {
  return props.theme.color.base3;
}, function (props) {
  return props.theme.size['3'];
});

Description.displayName = 'Description';
var Background = exports.Background = _styledComponents2.default.div(_templateObject8, function (props) {
  return props.animationDuration + 200;
}, function (props) {
  return props.animationDelay + 200;
}, function (props) {
  return props.animate && animateIn;
}, function (props) {
  return background[props.background];
}, function (props) {
  return props.imageHeight;
}, function (props) {
  return props.imageMarginTop;
}, function (props) {
  return props.imageWidth;
}, function (props) {
  return props.animate ? 0 : 1;
});
Background.displayName = 'Background';


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-content-not-available/styles.js
// module id = 2897
// module chunks = 4